import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import NodeAPI from "../api";
import { Box, Card, CardContent, Typography, Button, CircularProgress, IconButton, Menu, MenuItem } from "@mui/material";
import QuizQuestionCard from "./QuizQuestionCard";
import { isAnswerCorrect } from "../components/semanticChecker"; // adjust path
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Confetti from "react-confetti"; // ✅ Add this
import { useWindowSize } from "react-use";

const QuizPage = () => {
    const { topicId } = useParams();
    const navigate = useNavigate();
    const { user } = useAuth();

    const [questions, setQuestions] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [score, setScore] = useState(0);
    const [selectedAnswer, setSelectedAnswer] = useState(null);

 const { width, height } = useWindowSize(); // Get screen size for Confetti



// Inside your component:
const [anchorEl, setAnchorEl] = useState(null);
const open = Boolean(anchorEl);

const handleMenuClick = (event) => {
  setAnchorEl(event.currentTarget);
};

const handleMenuClose = (route) => {
  setAnchorEl(null);
  if (route) navigate(route);
};

const handleLogout = () => {
  setAnchorEl(null);
  // Add logout logic here
  navigate("/login");
};


const exitQuiz = () => {
        // ? Remove JWT token from localStorage or sessionStorage
        localStorage.removeItem("token"); // or sessionStorage.removeItem("token");
    
        // ? Clear any user context if used
       // setUser(null); // If using AuthContext
    
        // ? Navigate to home or login page
        navigate("/");
    };

    useEffect(() => {
        if (!user) return;
        NodeAPI.get(`/quiz/quiz/${topicId}?userId=${user.id}`)
            .then(({ data }) => setQuestions(data))
            .catch((err) => console.error("Error fetching questions:", err));
    }, [topicId, user]);

   /* const handleAnswer = (answer) => {
        if (selectedAnswer) return;

        const correctAnswer = questions[currentIndex].correct_answer;
        if (answer === correctAnswer) {
            setScore((prev) => prev + 1);
        }

        setSelectedAnswer(answer);
        setTimeout(() => {
            setSelectedAnswer(null);
            setCurrentIndex((prev) => prev + 1);
        }, 1000);
    };*/

const handleAnswer = async (answer) => {
    if (selectedAnswer) return;

    const currentQuestion = questions[currentIndex];
    const correctAnswer = currentQuestion.correct_answer;

    let isCorrect = false;

    if (!currentQuestion.options?.length) {
        // Structured question — use AI to check
        try {
            isCorrect = await isAnswerCorrect(answer, correctAnswer);
        } catch (err) {
            console.error("AI validation failed:", err);
        }
    } else {
        // Multiple choice — use direct match
        isCorrect =
            typeof answer === "string" &&
            correctAnswer.trim().toLowerCase() === answer.trim().toLowerCase();
    }

    if (isCorrect) {
        setScore((prev) => prev + 1);
    }

    setSelectedAnswer(answer);
    setTimeout(() => {
        setSelectedAnswer(null);

        setCurrentIndex((prev) => prev + 1);
    }, 1000);
};



    if (!questions.length) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                <CircularProgress />
            </Box>
        );
    }
 const scorePercent = (score / questions.length) * 100;
    const showConfetti = scorePercent >= 80; // Show if score >= 80%
   

   if (currentIndex >= questions.length) {
   

    return (
        <>
            {showConfetti && <Confetti width={width} height={height} />}
            <Card sx={{ maxWidth: 500, mx: "auto", mt: 5, textAlign: "center", boxShadow: 3 }}>
                <CardContent>
                    <Typography variant="h4" fontWeight="bold" gutterBottom>
                        Quiz Completed!
                    </Typography>
                    <Typography variant="h5" color="primary">
                        Your Score: {score}/{questions.length}
                    </Typography>
                    {showConfetti && (
                        <Typography variant="body1" sx={{ mt: 1 }}>
                            🎉 Awesome! You did great!
                        </Typography>
                    )}
                    <Button 
                        variant="contained" 
                        color="secondary" 
                        sx={{ mt: 2, mr: 2 }}
                        onClick={() => {
                            setCurrentIndex(0);
                            setScore(0);
                        }}
                    >
                        Retake Quiz
                    </Button>
                    <Button 
                        variant="outlined" 
                        color="error" 
                        sx={{ mt: 2 }}
                        onClick={() => navigate("/categories")}
                    >
                        Back to Categories
                    </Button>
                </CardContent>
            </Card>
        </>
    );
}


    const shuffledOptions = [...questions[currentIndex].options].sort(() => Math.random() - 0.5);

  return (
  <Box>
    {/* Header with Profile Menu */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
        px: 2,
        pt: 2,
      }}
    >
      <Typography variant="h4" sx={{ fontWeight: "bold" }}>
        Quiz
      </Typography>

      <div>
        <IconButton
          color="primary"
          onClick={handleMenuClick}
          aria-controls="profile-menu"
          aria-haspopup="true"
          size="large"
        >
          <AccountCircleIcon />
        </IconButton>
        <Menu
          id="profile-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={() => handleMenuClose()}
        >
          <MenuItem onClick={() => handleMenuClose("/profile")}>Profile</MenuItem>
          <MenuItem onClick={() => handleMenuClose("/notifications")}>Quiz Notifications</MenuItem>
          <MenuItem onClick={() => handleMenuClose("/uploadquiz")}>Upload Quiz</MenuItem>
          <MenuItem onClick={() => handleMenuClose("/generate_quiz")}>Generate Quiz</MenuItem>
            <MenuItem onClick={() => handleMenuClose("/categories")}>Categories</MenuItem>
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </div>
    </Box>
        <QuizQuestionCard key={currentIndex}
          question={questions[currentIndex].question}
          options={shuffledOptions}
          selectedAnswer={selectedAnswer}
          correctAnswer={questions[currentIndex].correct_answer}
          onAnswer={handleAnswer} />
            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
                <Button variant="outlined" onClick={() => navigate("/categories")} color="info">
                    Back to Categories
                </Button>
                <Button variant="contained" color="error" onClick={exitQuiz}>
                    Exit Quiz
                </Button>
            </Box>
  </Box>
);
   
};

export default QuizPage;
